import stableStringify from "fast-json-stable-stringify";

import type { PermissionsV2QueryVariables } from "src/graphql/types";

export type ResourcePermissionCacheInput = PermissionsV2QueryVariables;

export const buildPermissionCacheKey = (
  input: ResourcePermissionCacheInput,
): string => stableStringify(input);
